import React from "react";
import * as S from "./ModalExtratoStyle";
import { FaTimes } from "react-icons/fa";

export default function ModalExtrato({ isOpen, onClose, data }) {
  if (!isOpen || !data) return null;

  return (
    <S.Overlay onClick={onClose}>
      <S.Container onClick={(e) => e.stopPropagation()}>
        <S.Header>
          <h2>Detalhes do Extrato #{data.id}</h2>
          <button onClick={onClose}>
            <FaTimes />
          </button>
        </S.Header>

        <S.Body>
          <S.InfoRow>
            <span className="label">Data de Criação</span>
            <span className="value">
              {data.dateCreated
                ? new Date(data.dateCreated).toLocaleString("pt-BR")
                : "-"}
            </span>
          </S.InfoRow>

          <S.InfoRow>
            <span className="label">Caixinha Relacionada</span>
            <span className="value">
              {data.goldenBoxId ? `#${data.goldenBoxId}` : "N/A"}
            </span>
          </S.InfoRow>

          <S.DescriptionBox>
            <h4>Descrição do Evento</h4>
            <p>{data.description}</p>
          </S.DescriptionBox>
        </S.Body>

        <S.Footer>
          <S.Button onClick={onClose}>Fechar</S.Button>
        </S.Footer>
      </S.Container>
    </S.Overlay>
  );
}
